import React from 'react';

import { Col, Row } from 'reactstrap';
import styled, { css } from 'styled-components';
import { prop, switchProp } from 'styled-tools';

import TextColumn from 'components/ModularBlocks/TextBlock/TextColumn';
import StackHeader from 'components/StackHeader';

import { HeaderType } from 'interfaces/content-stack/contentStack.types';
import { TextBlockI } from 'interfaces/content-stack/modular-blocks/textBlock';
import { ContentAlignmentType } from 'interfaces/styles';

import { columnSpanMap } from 'utils/constants';

interface TextBlockContentProps {
  data: TextBlockI;
}

const FlexRow = styled(Row)`
  display: flex;
  grid-row-gap: 5rem;
`;

const HeaderContainer = styled.div<{ $type: HeaderType; $textAlign: ContentAlignmentType }>`
  text-align: ${prop('$textAlign', 'left')};

  ${switchProp('$type', {
    'Page Title': css`
      padding: 3.75rem 0 3.5rem;
    `,
    'Homepage Title': css`
      padding: 3.75rem 0 3.5rem;

      p {
        font-family: ${(props) => props.theme.fonts.condensed}};
        font-size: 2.125rem;
        line-height: 1.2;
      }
    `,
  })}
`;

const TextBlockContent: React.FC<TextBlockContentProps> = ({ data }) => {
  const { header, headerColor, headerType, subheader, subheaderType, contentSpan, contentAlignment, textColumns } =
    data;

  const colCount = (contentSpan && columnSpanMap[contentSpan]) || 'auto';

  return (
    <>
      {(header || subheader) && (
        <FlexRow>
          <Col sm={12} md={colCount}>
            <HeaderContainer $type={headerType} $textAlign={contentAlignment}>
              {header && (
                <StackHeader headerPrimaryColor={headerColor} defaultHeaderType='H2' headerType={headerType}>
                  {header}
                </StackHeader>
              )}
              {subheader && (
                <StackHeader defaultHeaderType='H5' headerType={subheaderType}>
                  {subheader}
                </StackHeader>
              )}
            </HeaderContainer>
          </Col>
        </FlexRow>
      )}
      {textColumns?.length > 0 && (
        <FlexRow>
          {textColumns.map((column, index) => (
            <TextColumn data={column} key={index} />
          ))}
        </FlexRow>
      )}
    </>
  );
};

export default React.memo(TextBlockContent);
